import React, { FunctionComponent } from "react";
import { Box, Text } from "@chakra-ui/react";

export const ComingSoonBadge: FunctionComponent = () => {
	return (
		<Box display="flex" alignItems="center" textColor="neutrals.800" bg="neutrals.50" borderRadius="md" px={2} py={0.5}>
			<Text fontSize="xs" fontWeight={600}>
				COMING SOON
			</Text>
		</Box>
	);
};
